import axios from "axios";
import Nprogress from "nprogress";
import { app } from "../main";

const apiClient = axios.create({
  baseURL: "https://iccs340-project-4c21f-default-rtdb.asia-southeast1.firebasedatabase.app/myNFTs.json",
});

apiClient.interceptors.request.use(
    config => {
        Nprogress.start();
        return config;
    }
);

apiClient.interceptors.request.use(
    response => {
        Nprogress.done();
        return response;
    }
);

export default {
    getPreRegis() {
        let url =
            "https://iccs340-project-4c21f-default-rtdb.asia-southeast1.firebasedatabase.app/myNFTs.json?auth=" + app.config.globalProperties.$idToken;
            app.config.globalProperties.$idToken;
        return apiClient.get(url);
    },
    postPreRegis(theObj) {
        // this is the url when user login already. 
        let url =
            "https://iccs340-project-4c21f-default-rtdb.asia-southeast1.firebasedatabase.app/myNFTs.json?auth=" + app.config.globalProperties.$idToken;
            app.config.globalProperties.$idToken;
        // if the user signed in, the url shouldn't have this part: "?auth=" 
        if (!app.config.globalProperties.$authenticated) {
            url = 
                "https://iccs340-project-4c21f-default-rtdb.asia-southeast1.firebasedatabase.app/myNFTs.json"
        }   
        return apiClient.post(url, theObj);
    },
    // deletePreRegis(theObj) {
    //     // this is the url when user login already. 
    //     let url =
    //         "https://iccs340-project-4c21f-default-rtdb.asia-southeast1.firebasedatabase.app/myNFTs.json?auth=" + app.config.globalProperties.$idToken;
    //         app.config.globalProperties.$idToken;
    //     // if the user signed in, the url shouldn't have this part: "?auth=" 
    //     if (!app.config.globalProperties.$authenticated) {
    //         url = 
    //             "https://iccs340-project-4c21f-default-rtdb.asia-southeast1.firebasedatabase.app/myNFTs.json"
    //     }   
    //     return apiClient.delete(url, theObj);
    // },
}